import { get } from 'lodash-es';
import type { FC, ReactNode } from 'react';

import type { FormInstance } from '@zen/Components/Form/types';
import { Switch } from '@zen/DesignSystem';

import type { FormFieldProps } from '../FormField';
import FormField from '../FormField';

interface Props extends FormFieldProps {
  hideLabel?: boolean;
  isDisabled?: boolean;
  labelHint?: string;
  onChange?: (isChecked: boolean) => void;
}

const FormSwitch: FC<Props> = (props) => {
  const { className, hideLabel, label, isDisabled } = props;

  return (
    <FormField {...props} hideLabel={true}>
      {(field: { id: string; name: string }, form: FormInstance<unknown>) => {
        const { name } = field;
        const isChecked: boolean = !!get(form.values, name);
        const handleChange = (): void => {
          form.setFieldValue(name, !isChecked);

          props.onChange?.(!isChecked);
        };

        const switchLabel: ReactNode = hideLabel ? null : label;

        return (
          <div className="flex items-center">
            <Switch
              {...field}
              className={className}
              isChecked={isChecked}
              isDisabled={isDisabled}
              label={switchLabel}
              name={name}
              onChange={handleChange}
            />
          </div>
        );
      }}
    </FormField>
  );
};

export default FormSwitch;
